export default "__VITE_ASSET__$na8X8Yu__"